/* eslint-disable no-case-declarations */
import * as R from 'ramda';
import { SET_CURRENT_WFS, CLEAR_CURRENT_WFS } from 'actions/payway';
const initialState = null;

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_WFS:
      return { ...action.payload, updated: true };
    case CLEAR_CURRENT_WFS:
      if (action.shouldLeaveTelmex) {
        if (state?.gateway === 'telmexmexicogate') {
          return state;
        }
      }
      return null;
    default:
      return state;
  }
}
